<template>
  <v-menu open-on-hover transition="slide-x-transition"  offset-y>
    <template v-slot:activator="{ on, attrs }">
        <v-btn icon large v-bind="attrs" v-on="on">
            {{ language }}
        </v-btn>
    </template>
    <v-card class="mx-auto" max-width="300" tile>
        <v-list >
            <v-list-item-group >
                <v-list-item @click="changeLanguage('fr')">
                    <v-list-item-action>
                        <v-list-item-title >{{$t('menu.language.french')}}</v-list-item-title>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item @click="changeLanguage('en')">
                    <v-list-item-action>
                        <v-list-item-title >{{$t('menu.language.english')}} </v-list-item-title>
                    </v-list-item-action>
                </v-list-item>
            </v-list-item-group>
        </v-list>
      </v-card>
    </v-menu>
</template>

<script>
import i18n from '../../i18n.js';
import { mapActions,mapState } from 'vuex';
import NotificationMixin from '../../mixins/NotificationMixin';
export default {
  name: 'LanguageNavigation',
  servicePrefix: 'user',
  mixins: [NotificationMixin],
  methods: {
    ...mapActions({
      userPushAction: 'user/action',
    }),
    changeLanguage(language) {
      this.$cookie.set('LANGUAGE', language, 1);
      i18n.locale = language;
      this.userPushAction({action: 'changeLanguage',values: {'language' :language}});
    },
    changedLanguage(item) {
        item.message && this.showMessage(item.message);
    },
  },
  computed: {
    ...mapState('user', {
      actioned: 'actioned',
      action: 'action',
      error: 'error',
      isLoading: 'isLoading',
    }),
    language() {
      return i18n.locale;
    }
  },
  watch: {
    actioned(actioned) {
      if (!actioned) {
        return;
      }
      if (this.action == 'changeLanguage') {
        this.changedLanguage(actioned);
      }
    },
    error(message) {
      if (message != 'NotConnected') {
        message && this.showError(message);
      }
    }
  }
};
</script>
